// Pulled from https://git.hubteam.com/HubSpot/CrmRecordCards/blob/88bafe031b3c5a75757b8d7119204003cdc5cac7/CrmRecordCardsBase/src/main/java/com/hubspot/crm/record/cards/base/ContainerFeature.java#L22
// Default tabs specific to the record page
const RECORD_PAGE_TABS = ['ORIGINAL_OVERVIEW_TAB', 'INTELLIGENCE_TAB', 'ACTIVITIES_TAB', 'ABOUT_TAB', 'FINANCE_TAB', 'CATCH_UP_TAB'];
export const getTabNameForTracking = (content, label) => {
  var _content$containerFea, _content$containerFea2;
  if (content.type !== 'CONTAINER') {
    return label;
  }
  return (_content$containerFea = (_content$containerFea2 = content.containerFeatures) === null || _content$containerFea2 === void 0 ? void 0 : _content$containerFea2.find(containerFeature => RECORD_PAGE_TABS.includes(containerFeature))) !== null && _content$containerFea !== void 0 ? _content$containerFea : label;
};
export function getHasCustomTabs(tabs) {
  return tabs.some(tab => {
    var _tab$content$containe;
    if (tab.content.type !== 'CONTAINER') {
      return false;
    }
    const hasRecordPageTab = (_tab$content$containe = tab.content.containerFeatures) === null || _tab$content$containe === void 0 ? void 0 : _tab$content$containe.some(feature => RECORD_PAGE_TABS.includes(feature));
    return !hasRecordPageTab;
  });
}